module.exports = __webpack_public_path__ + "static/pp_odwrotne-33c6f0c4c8d562111c56e8d6ed913da3.gif";